import { ClassType, db } from "../../mp-database"
import { getSchoolYear } from "../../mp-utils/generic-utils"
import { fetchCreators } from "./fetchCreators"

export const fetchClasses = async (teacherId?: string) => {
  let query: any = db.collection("classes")

  if (teacherId) {
    query = query.where("teacher", "==", teacherId)
  }

  const currentYear = getSchoolYear()
  query = query.where("schoolYear", "in", [
    currentYear.year,
    currentYear.year.toString()
  ])

  const classes = (await query.get()).docs.map(item => item.data() as ClassType)
  return fetchCreators<ClassType>(classes)
}

export const fetchClassById = async (
  classId: string,
  teacherId?: string
): Promise<ClassType> => {
  let query: any = db.collection("classes").where("id", "==", classId)

  if (teacherId) {
    query = query.where("teacher", "==", teacherId)
  }

  return (await query.get()).docs.map(item => item.data() as ClassType)?.[0]
}
